export const editorBringObjectToFront = () => {
  const selection = window.canvas && window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  if (typeof selection.bringToFront === 'function') {
    selection.bringToFront();
  } else if (window.canvas) {
    // Fallback for non-fabric objects: move to top of stack
    window.canvas.bringToFront(selection);
  }
  window.canvas && window.canvas.renderAll();
};
